import { GameAssetsSpecificationsInterface } from '../interfaces/game-element-specifications-interface';
import { GameElementsString } from './game-constants-strings/game-elements-strings';

// const gameAssetsPath = '../assets/game-assets/boot-load-assets/scene-backgrounds-assets';
// public\game-assets\boot-load-assets\backgrounds-assets\scene-background.png
const gameAssetsBackgroundsPath = 'game-assets/boot-load-assets/scene-backgrounds-assets/';
const gameAssetsButtonsPath = 'game-assets/boot-load-assets/buttons-assets/';
const gameAssetsFiguresPath = 'game-assets/boot-load-assets/figures-assets/';
const gameAssetsIconsPath = 'game-assets/boot-load-assets/icons-assets/';
const gameAssetsCardsPath = 'game-assets/boot-load-assets/cards-assets/';
// const gameAssetsBackgroundsPath = 'game-assets/boot-load-assets/';

export const gameAssets: GameAssetsSpecificationsInterface[] = [

    /*************************** BACKGROUNS *******************************/
    // {
    //     type: GameElementsString.IMAGE_STRING,
    //     key: 'game-scene',
    //     path: gameAssetsBackgroundsPath + 'scene-background.png'
    // },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'modal-scene-background',
        path: gameAssetsBackgroundsPath + 'modal-scene-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'main-scene-background',
        path: gameAssetsBackgroundsPath + 'main-scene-background.png'
    },

    /*************************** BUTTONS *******************************/
   
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'red-button-background',
        path: gameAssetsButtonsPath + 'red-button-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'green-button-background',
        path: gameAssetsButtonsPath + 'green-button-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'blue-button-background',
        path: gameAssetsButtonsPath + 'blue-button-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'play-button-background',
        path: gameAssetsButtonsPath + 'play-button-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'continue-button-background',
        path: gameAssetsButtonsPath + 'continue-button-background.png'
    },
    
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'next-button-background',
        path: gameAssetsButtonsPath + 'next-button-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'quit-button-background',
        path: gameAssetsButtonsPath + 'quit-button-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'play-game-button-background',
        path: gameAssetsButtonsPath + 'play-game-button-background.png'
    },
    
    /*************************** FIGURES *******************************/
   
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'ball-background',
        path: gameAssetsFiguresPath + 'ball-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'pipe-background',
        path: gameAssetsFiguresPath + 'pipe-black-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'pipe-red-background',
        path: gameAssetsFiguresPath + 'pipe-red-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'pipe-green-background',
        path: gameAssetsFiguresPath + 'pipe-green-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'pipe-blue-background',
        path: gameAssetsFiguresPath + 'pipe-blue-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'game-scene',
        path: gameAssetsFiguresPath + 'scene-background.png'
    },
    
    /*************************** ICONS *******************************/
   
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'close-button-background',
        path: gameAssetsIconsPath + 'close-button-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'help-icon-background',
        path: gameAssetsIconsPath + 'help-icon-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'info-icon-background',
        path: gameAssetsIconsPath + 'info-icon-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'return-icon-background',
        path: gameAssetsIconsPath + 'return-icon-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'settings-icon-background',
        path: gameAssetsIconsPath + 'settings-icon-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'one-background',
        path: gameAssetsIconsPath + 'one-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'two-background',
        path: gameAssetsIconsPath + 'two-background.png'
    },
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'three-background',
        path: gameAssetsIconsPath + 'three-background.png'
    },
    
    /*************************** CARDS *******************************/
    
    {
        type: GameElementsString.IMAGE_STRING,
        key: 'panel-card-background',
        path: gameAssetsCardsPath + 'panel-card-background.png'
    },


    
    // {
    //     type: GameElementsString.IMAGE_STRING,
    //     key: 'ball',
    //     path: gameAssetsFiguresPath + 'ball.png'
    // },
    // {
    //     type: GameElementsString.IMAGE_STRING,
    //     key: 'ball-background',
    //     path: gameAssetsFiguresPath + 'ball-background.png'
    // },
    // {
    //     type: GameElementsString.IMAGE_STRING,
    //     key: 'pipe-background',
    //     path: gameAssetsFiguresPath + 'pipe-background.png'
    // },
    // {
    //     type: GameElementsString.IMAGE_STRING,
    //     key: 'pipe',
    //     path: gameAssetsPath + 'pipe.png'
    // },
    // {
    //     type: GameElementsString.IMAGE_STRING,
    //     key: 'scene-background',
    //     path: gameAssetsPath + 'scene-background.png'
    // },
];